export default "__VITE_ASSET__CyT3GNWx__"